import React from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FormControl } from '@material-ui/core';
import strings from './language/language';

const RadioButton = props => {
  return (
    <div className='item-container'>
      <div className='addons-row'>
        <FormControl>
          <RadioGroup
            onChange={props.click}
            name={props.name}
            value={props.value}
          >
            {props.items.map(item => {
              return (
                <FormControlLabel
                  className='options'
                  value={
                    item.price
                      ? item.item_name + '%' + item.price
                      : item.item_name
                  }
                  as
                  control={
                    <Radio
                      labelStyle={{ color: '#70142C' }}
                      iconStyle={{ fill: '#70142C' }}
                      inputStyle={{ color: '#70142C' }}
                      style={{ color: '#70142C' }}
                    />
                  }
                  label={
                    <React.Fragment>
                      <div className='addon-name' variant='headline'>
                        {item.item_name}
                      </div>
                      <div className='addon-price'>
                        {' '}
                        {item.price ? '+ ' + item.price + strings.currency : ''}
                      </div>
                    </React.Fragment>
                  }
                />
              );
            })}
            {/* <MultiSelect prices={props.items}  /> */}
            {/* <FormControlLabel className="options" value="" checked="" control={<Radio labelStyle={{color: '#1c9a52'}}
                            iconStyle={{fill: '#1c9a52'}}
                            inputStyle={{color:'#1c9a52'}}
                            style={{color:'#1c9a52'}}/>} label = {props.option} /> */}
          </RadioGroup>
        </FormControl>
      </div>
    </div>
  );
};
export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/genericselection.js